/**
 * POST /feedback — submit user feedback for un turno (correlacionado por trace_id).
 *
 * T-03-02-13 documenta que /feedback NO requiere HMAC X-Device-Token (analytics
 * post-hoc, device_id Pydantic-validated server-side + presence check). Por eso
 * NO usamos el helper HMAC del client.ts — es POST simple JSON.
 *
 * Best-effort: si el POST falla (network, 4xx, 5xx) el caller decide cómo
 * mostrar el error. NO retry automático — feedback es opcional (D-UI-FB-02).
 */
import type { FeedbackPayload } from '../types/feedback'

export async function submitFeedback(payload: FeedbackPayload): Promise<void> {
  const res = await fetch('/api/feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) {
    // T-04-01-07 sanitization parity: NO incluir body remoto. Caller mapea
    // a UX genérico ("Error enviando feedback").
    throw new Error(`feedback_${res.status}`)
  }
}
